import { useState } from "react";
import { NOTE, tone, drum } from "@/lib/babySound";

const KEYS = [["C4", "#E57373"], ["D4", "#F28C38"], ["E4", "#F2C94C"], ["G4", "#9BD08A"], ["A4", "#5AC8C8"], ["C5", "#6BB3E0"], ["D5", "#A68BE0"], ["E5", "#E58FB8"]];
const DRUMS = [["boom", "Boom", "#2C4A3E"], ["tap", "Tap", "#C87D53"], ["shake", "Shake", "#6B9080"]];

export const PianoDrums = () => {
  const [on, setOn] = useState(null);
  const flash = (k) => { setOn(k); setTimeout(() => setOn((x) => (x === k ? null : x)), 220); };
  return (
    <div className="absolute inset-0 flex flex-col gap-4 p-4 pt-24 bg-[#FDFBF7]" data-testid="game-piano">
      <div className="flex-1 grid grid-cols-8 gap-2">
        {KEYS.map(([n, c]) => (
          <button key={n} onPointerDown={() => { tone(NOTE[n], 0.9, { type: "triangle", vol: 0.22 }); flash(n); }} data-testid={`piano-${n}`} aria-label={`Note ${n}`}
            className={`rounded-b-3xl rounded-t-lg transition-transform duration-150 ${on === n ? "scale-y-95 brightness-110" : ""}`} style={{ background: c, boxShadow: `inset 0 -12px 0 ${c}99` }} />
        ))}
      </div>
      <div className="h-[30%] grid grid-cols-3 gap-4">
        {DRUMS.map(([k, label, c]) => (
          <button key={k} onPointerDown={() => { drum(k); flash(k); }} data-testid={`drum-${k}`}
            className={`rounded-full font-display text-2xl text-white transition-transform duration-150 ${on === k ? "scale-90" : ""}`} style={{ background: c }}>{label}</button>
        ))}
      </div>
    </div>
  );
};
